import Services from "../../services";

class PengakuanHutangApi {
  // API SERVER
  get(params) {
    return Services.get("hrdu/approval_non_voucher_invoice/list", { params });
  }

  getHistory(params) {
    return Services.get("hrdu/approval_non_voucher_invoice/history/list", {
      params,
    });
  }

  getSingle(params) {
    return Services.get("hrdu/approval_non_voucher_invoice/detail", { params });
  }

  approve(data) {
    return Services.post("hrdu/approval_non_voucher_invoice/approve", data);
  }
}

export default new PengakuanHutangApi();
